import React, { useEffect, useState } from "react";
import { useAuth } from "../context/auth";
import { useGuestbook } from "../context/guestbook";
import Input from "../components/Input";
import Button from "./Button";

export default function GuestbookInput() {
  const { currentUser } = useAuth();
  const { addEntry } = useGuestbook();
  const [text, setText] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    // Clean up event listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    addEntry(text);
    setText("");
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "75%",
        marginBottom: "25px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <textarea
          style={{
            width: isMobile ? "100%" : "33%",
            marginBottom: "5px",
            minHeight: "125px",
            marginBottom: "5px",
            border: "3px outset rgb(212, 212, 212)",
          }}
          placeholder="Comments about your stay..."
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
        <Button
          type="submit"
          style={{ width: isMobile ? "100%" : "34.5%" }}
          disabled={!text}
        >
          𓂃🖊 Signed, {currentUser?.data?.displayName || "Dilnod"}
        </Button>
      </div>
    </form>
  );
}
